import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { LayoutContext } from '@lib/site-context'
import { useContext, type ReactNode } from 'react'
import Photo from './photo'

interface HeroLogoProps {
  logo: SanityImageFragment
  children: ReactNode
}

const HeroLogo = ({ logo, children }: HeroLogoProps) => {
  const { headerHeight } = useContext(LayoutContext)

  return (
    <div className="relative">
      <div
        id="hero-logo"
        className="absolute z-[1] top-1/3 bottom-0 inset-x-0 pointer-events-none"
      >
        <Photo
          image={logo}
          imageClassName="w-full"
          showPlaceholder={false}
          className="sticky pt-10 pb-5 max-w-[80%] mx-auto"
          style={{
            top: headerHeight,
          }}
        />
      </div>
      {children}
    </div>
  )
}

export default HeroLogo
